// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NGzTmEFsiwU93koZ1FnO{background:var(--border-neutral-default);width:calc(100% - 40px);height:1px;margin:16px 20px;display:flex}.chc_GThabC4ebbgKEybN{justify-content:space-between;padding:8px 20px 12px;display:flex}.LhlB1cX8LUEs9M64Ol0y{align-items:center;gap:10px;display:flex}.LhlB1cX8LUEs9M64Ol0y input{height:20px;font-size:16px}.CYsOTLAjvOwNE7X_Eja_{flex-grow:1;margin-left:16px;display:flex;position:relative}.idOA83p5cmUA5Pk0e7bY{justify-content:space-between;align-items:center;gap:12px;display:flex}.poT13iSO2YAJOm_yRlNL{align-items:center;gap:12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separator": `NGzTmEFsiwU93koZ1FnO`,
	"searchWrap": `chc_GThabC4ebbgKEybN`,
	"search": `LhlB1cX8LUEs9M64Ol0y`,
	"wrapTable": `CYsOTLAjvOwNE7X_Eja_`,
	"contactColumn": `idOA83p5cmUA5Pk0e7bY`,
	"contactColumnName": `poT13iSO2YAJOm_yRlNL`
};
export default ___CSS_LOADER_EXPORT___;
